var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.807 1.14c.343-.19.76-.187 1.102.008l9.168 5.228-1.116 1.956-8.62-4.915-11.09 6.13V22.07l11.095 6.497 10.942-6.492V12.42h2.252v10.296c0 .397-.21.765-.552.968l-12.064 7.158c-.352.21-.79.21-1.144.004L3.557 23.687A1.126 1.126 0 0 1 3 22.716V8.882c0-.41.223-.787.581-.985L15.808 1.14zm1.831 7.983h-5.63v1.93h5.562c.378.06.963.256 1.458.652.49.392.896.98.944 1.893.048.91-.287 1.443-.682 1.782-.418.358-.95.533-1.306.58h-5.976a.965.965 0 0 0-.965.965v5.228h1.93V17.89h5.067a.975.975 0 0 0 .101-.005 4.56 4.56 0 0 0 2.407-1.04c.83-.711 1.433-1.814 1.352-3.349-.081-1.531-.802-2.607-1.666-3.299a5.175 5.175 0 0 0-2.473-1.066.965.965 0 0 0-.122-.007zm4.015 12.304-2.171-2.413-1.435 1.291 2.171 2.413 1.435-1.291zm6.2-10.454a1.77 1.77 0 1 0 0-3.539 1.77 1.77 0 0 0 0 3.54z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRay);
export default __webpack_public_path__ + "static/media/RAY.e79848cda269c9e5294b6e71330b7641.svg";
export { ForwardRef as ReactComponent };